export const ROUTES = {
  HOME: '/',

  LOGIN: '/login',
  REGISTER: '/register',

  BLOGGERS: '/bloggers',

  ESTIMATES: '/estimates',
  ESTIMATE_NEW: '/estimates/new',
  ESTIMATE_IMPORT: '/estimates/import',
  ESTIMATE: '/estimates/:id',

  NOT_FOUND: '/404',
} as const;

export function estimatePath(id: number): string {
  return `/estimates/${id}`;
}

/** Мастер создания: источник «Скопировать смету» с подставленной сметой. */
export function estimateCopyPath(fromId: number): string {
  return `${ROUTES.ESTIMATE_NEW}?source=copy&from=${fromId}`;
}
